import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeStyle as _normalizeStyle, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2855f82"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-search-status"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Buscando…", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 2,
  class: "header-search-status"
}

import { IonSearchbar, IonList, IonItem, IonItemDivider, IonLabel, IonIcon, IonSpinner } from '@ionic/vue'
import { peopleOutline, gitBranchOutline, alertCircleOutline } from 'ionicons/icons'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { currentUserStore } from '@/stores/currentUser'
import { SearchService, BusquedaEntidad, BusquedaGlobal } from '@/services/SearchService'


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderSearch',
  setup(__props) {

const router = useRouter()
const userStore = currentUserStore()
const wrapRef = ref<HTMLElement | null>(null)
const query = ref('')
const loading = ref(false)
const searched = ref(false)
const panelOpen = ref(false)
const panelStyle = ref<Record<string, string>>({})
const results = ref<BusquedaGlobal>({
	entidades: [],
	procesos: [],
	incidencias: [],
})

const canEntidades = computed(() => userStore.permissionNames.includes('user list'))
const canProcesos = computed(() => userStore.permissionNames.includes('procesos list'))
const canIncidencias = computed(() => userStore.permissionNames.includes('incidencias list'))
const canSearch = computed(() => canEntidades.value || canProcesos.value || canIncidencias.value)

const placeholder = computed(() => {
	const parts: string[] = []
	if (canEntidades.value) parts.push('entidades')
	if (canProcesos.value) parts.push('procesos')
	if (canIncidencias.value) parts.push('incidencias')
	if (parts.length === 0) return 'Buscar'
	if (parts.length === 1) return `Buscar ${parts[0]}…`
	return `Buscar ${parts.slice(0, -1).join(', ')} o ${parts[parts.length - 1]}…`
})

const hasResults = computed(() =>
	results.value.entidades.length + results.value.procesos.length + results.value.incidencias.length > 0
)

function entidadSubtitle(item: BusquedaEntidad): string {
	return [item.nif, item.mainTlf, item.mainEmail].filter(Boolean).join(' · ')
}

function positionPanel() {
	const el = wrapRef.value
	if (!el) return
	const rect = el.getBoundingClientRect()
	const left = Math.max(8, rect.left)
	const width = Math.min(rect.width, window.innerWidth - left - 8)
	panelStyle.value = {
		top: `${Math.round(rect.bottom + 4)}px`,
		left: `${Math.round(left)}px`,
		width: `${Math.round(Math.max(width, 240))}px`,
	}
}

async function onInput(ev?: CustomEvent) {
	const term = String(ev?.detail?.value ?? query.value).trim()
	if (term.length < 3) {
		clearResults()
		return
	}
	positionPanel()
	panelOpen.value = true
	loading.value = true
	searched.value = false
	try {
		results.value = await SearchService.buscar(term)
		searched.value = true
	} finally {
		loading.value = false
		positionPanel()
	}
}

function onFocus() {
	if (query.value.trim().length >= 3 && (hasResults.value || searched.value)) {
		positionPanel()
		panelOpen.value = true
	}
}

function clearResults() {
	results.value = { entidades: [], procesos: [], incidencias: [] }
	searched.value = false
	loading.value = false
	panelOpen.value = false
}

function closeAndReset() {
	query.value = ''
	clearResults()
}

function goEntidad(item: BusquedaEntidad) {
	const filtro = query.value.trim() || item.nombre
	closeAndReset()
	router.push({ path: '/organizacion/usuarios', query: { item: filtro } })
}

function goProceso(id: number) {
	closeAndReset()
	router.push({ name: 'Proceso', params: { proceso_id: String(id) } })
}

function goIncidencia(id: number) {
	closeAndReset()
	router.push({ path: '/organizacion/incidencias', query: { incidencia: String(id) } })
}

function onDocumentClick(event: MouseEvent) {
	const target = event.target as Node | null
	if (!target) return
	if (wrapRef.value?.contains(target)) return
	const panel = document.querySelector('.header-search-panel')
	if (panel?.contains(target)) return
	panelOpen.value = false
}

function onKeydown(event: KeyboardEvent) {
	if (event.key === 'Escape') {
		panelOpen.value = false
	}
}

onMounted(() => {
	document.addEventListener('click', onDocumentClick)
	window.addEventListener('keydown', onKeydown)
	window.addEventListener('resize', positionPanel)
})

onUnmounted(() => {
	document.removeEventListener('click', onDocumentClick)
	window.removeEventListener('keydown', onKeydown)
	window.removeEventListener('resize', positionPanel)
})

return (_ctx: any,_cache: any) => {
  return (canSearch.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "header-search",
        ref_key: "wrapRef",
        ref: wrapRef
      }, [
        _createVNode(_unref(IonSearchbar), {
          modelValue: query.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
          placeholder: placeholder.value,
          debounce: "400",
          "show-clear-button": "focus",
          inputmode: "search",
          onIonInput: onInput,
          onIonClear: clearResults,
          onIonFocus: onFocus,
          onKeyup: _withKeys(onInput, ["enter"])
        }, null, 8, ["modelValue", "placeholder", "onKeyup"]),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          (panelOpen.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "header-search-panel",
                style: _normalizeStyle(panelStyle.value)
              }, [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createVNode(_unref(IonSpinner), { name: "crescent" }),
                      _hoisted_2
                    ]))
                  : (hasResults.value)
                    ? (_openBlock(), _createBlock(_unref(IonList), {
                        key: 1,
                        lines: "full"
                      }, {
                        default: _withCtx(() => [
                          (results.value.entidades.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_unref(IonItemDivider), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Entidades")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.entidades, (item) => {
                                  return (_openBlock(), _createBlock(_unref(IonItem), {
                                    key: 'e-' + item.id,
                                    button: "",
                                    onClick: ($event: any) => (goEntidad(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonIcon), {
                                        icon: _unref(peopleOutline),
                                        slot: "start",
                                        color: "primary"
                                      }, null, 8, ["icon"]),
                                      _createVNode(_unref(IonLabel), null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h3", null, _toDisplayString(item.nombre), 1),
                                          (entidadSubtitle(item))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(entidadSubtitle(item)), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ], 64))
                            : _createCommentVNode("", true),
                          (results.value.procesos.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_unref(IonItemDivider), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Procesos")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.procesos, (item) => {
                                  return (_openBlock(), _createBlock(_unref(IonItem), {
                                    key: 'p-' + item.id,
                                    button: "",
                                    onClick: ($event: any) => (goProceso(item.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonIcon), {
                                        icon: _unref(gitBranchOutline),
                                        slot: "start",
                                        color: "primary"
                                      }, null, 8, ["icon"]),
                                      _createVNode(_unref(IonLabel), null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                                          (item.estado)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item.estado), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ], 64))
                            : _createCommentVNode("", true),
                          (results.value.incidencias.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_unref(IonItemDivider), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Incidencias")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value.incidencias, (item) => {
                                  return (_openBlock(), _createBlock(_unref(IonItem), {
                                    key: 'i-' + item.id,
                                    button: "",
                                    onClick: ($event: any) => (goIncidencia(item.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonIcon), {
                                        icon: _unref(alertCircleOutline),
                                        slot: "start",
                                        color: "danger"
                                      }, null, 8, ["icon"]),
                                      _createVNode(_unref(IonLabel), null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                                          (item.estado)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(item.estado), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : (searched.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Sin resultados para «" + _toDisplayString(query.value.trim()) + "» ", 1))
                      : _createCommentVNode("", true)
              ], 4))
            : _createCommentVNode("", true)
        ]))
      ], 512))
    : _createCommentVNode("", true)
}
}

})